<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <SearchBar ref="searchRef" msg="B100" @search="onLoadTable" />
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onExportClick" v-show="store.getters.check_auth('PRINT')">下載明細</el-button>
                </el-row>
                <div ref="table" style="margin-top:10px;"></div>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import { useDownload } from '@/composables/download'
    import SearchBar from '@/components/SearchBar.vue'
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面

    const searchRef = ref(null);

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = (data) => {
        $api.GET('/api/DlvNote/GetTableData', data
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onExportClick = () => {
        $api.POST('/api/DlvNote/ExportExcel', {
            type: "record", param: searchRef.value.searchForm
        }).then((response) => {
            useDownload('/api/Home/DownloadFile?URL_ADDR=' + response, response.split('\\')[1]);
        });
    }

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            columns: [
                { title: "No", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "商店名稱", field: "DEPT_COMP_NAME", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "訂單日期", field: "DEPT_TIME", width: 90, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "訂單金額", field: "PRODUCT_AMT", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "商家訂單號", field: "WORK_NO", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "客戶名稱", field: "DEST_COMP_NAME", headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "外送平台", field: "TRN_LGS", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "平台訂單ID", field: "TRN_ORDER_ID", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "狀態", field: "LAST_STATUS_CODE", width: 60, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "距離/KM", field: "CHARGE_DLV_KM", width: 65, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "外送費", field: "CHARGE_AMT", width: 60, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false},
                {
                    title: "代收貨款", field: "COLLECT_AMT", width: 80, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        if (cell.getValue() == 0) {
                            return "";
                        } else {
                            return cell.getValue();
                        }
                    }
                },
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
    });

</script>

<style></style>
